import { render, staticRenderFns } from "./addHefr.vue?vue&type=template&id=652f945f"
import script from "./addHefr.vue?vue&type=script&lang=js"
export * from "./addHefr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports